import { KnownAuthError } from "@/api/client";
import { supabase } from "@/lib/supabase";
import type { User as SupabaseUser, UserIdentity } from "@supabase/supabase-js";
import { useSuspenseQuery } from "@tanstack/react-query";

export interface User extends SupabaseUser {
  id: string;
  aud: string;
  confirmation_sent_at?: string;
  recovery_sent_at?: string;
  email_change_sent_at?: string;
  new_email?: string;
  new_phone?: string;
  invited_at?: string;
  action_link?: string;
  email?: string;
  phone?: string;
  created_at: string;
  confirmed_at?: string;
  email_confirmed_at?: string;
  phone_confirmed_at?: string;
  last_sign_in_at?: string;
  role?: string;
  updated_at?: string;
  identities?: UserIdentity[];
  is_anonymous?: boolean;
  user_metadata: {
    name?: string;
    avatar_url?: string;
    picture?: string;
  };
}

export function useUser() {
  const { data } = useSuspenseQuery<User | null>({
    queryKey: useUser.queryKey(),
    queryFn: () => supabase.auth.getUser().then((res) => res.data.user as unknown as User),
  });

  if (data == null) {
    throw new KnownAuthError("Unauthorized", window.location.href);
  }

  return { data };
}

useUser.queryKey = () => ["user"];
